var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hitchRideCancelRule"},[_c('custom-city-tree',{attrs:{"url":"/api/v1/manage/hitchRide/refund/city"},on:{"city-selected":_vm.handleCitySelect}}),_c('div',{staticClass:"hitchRideCancelRule-content"},[_c('sellOrderRulesForm',{attrs:{"cityData":{ ..._vm.selectCity }}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }